import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, map, Observable } from 'rxjs';
import { Item } from '../domain/models/item';
import { ItemOperationError } from '../domain/errors/item-operation-error';
import IManageItems from '../domain/ports/i-manage-items';


@Injectable({ providedIn: 'root' })
export class ItemAdapterService implements IManageItems {

  private itemsUrl = environment.urlApi;  // URL to web api

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { }

  /** GET items from the server */
  getItems(term: string): Observable<Item> {
    return this.http.get<Item[]>(`${this.itemsUrl}api/v1/AppTest/TestNew?company=${term}`,{
      headers: new HttpHeaders({ 'Access-Control-Allow-Origin': window.location.href }),
    }).pipe(
      catchError(this.handleHttpError())
    );
  }

  /** GET items paginated from the server */
  getItemsPaged(term: string, pageIndex: number = 1, pageSize: number = 10): Observable<Item[]> {    
    return this.http.get<Item[]>(`${this.itemsUrl}api/v1/AppTest/TestNewPaged`, {
      headers: new HttpHeaders({ 'Access-Control-Allow-Origin': window.location.href }),
      params: {
        company: term,
        pageIndex: pageIndex.toString(),
        pageSize: pageSize.toString()
      }
    }).pipe(
      catchError(this.handleHttpError())
    );
}

  /** GET item by id. Will 404 if id not found */
  getItem(id: number): Observable<Item> {
    const url = `${this.itemsUrl}/${id}`;
    return this.http.get<Item>(url).pipe(
      catchError(this.handleHttpError())
    );
  }

  /* GET items whose name contains search term */
  searchItems(term: string): Observable<Item[]> { 
    return this.http.get<Item[]>(this.itemsUrl).pipe(
      catchError(this.handleHttpError())
    );
  }

  //////// Save methods //////////

  /** POST: add a new item to the server */
  addItem(item: Item): Observable<Item> {
    return this.http.post<Item>(this.itemsUrl, item, this.httpOptions).pipe(
      catchError(this.handleHttpError())
    );
  }

  /** DELETE: delete the item from the server */
  deleteItem(id: number): Observable<number> {
    const url = `${this.itemsUrl}/${id}`;
    return this.http.delete<Item>(url, this.httpOptions).pipe(
      catchError(this.handleHttpError()),
      // returns the deleted item id
      map(_ => id)
    );
  }

  /** PUT: update the item on the server */
  updateItem(item: Item): Observable<Item> {
    return this.http.put<Item>(this.itemsUrl, item, this.httpOptions).pipe(
      catchError(this.handleHttpError()),
      // returns the modified item
      map(_ => item)
    );
  }

  /**
   * Handle Http operation that failed.
   * Throw an ItemOperation
   */
   private handleHttpError() {
    return (error: any): Observable<any> => {
      console.error(error);
      throw new ItemOperationError(error.body.error);
    };
  }

}